import { Component, OnInit } from '@angular/core';
import { interval, Observable } from "rxjs";
import { AuthService } from './modules/auth/services/auth-service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: false
})
export class AppComponent implements OnInit {

  loading$: Observable<boolean>;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    // Verifica a cada 1 minuto se o token expirou
    interval(60000).subscribe(() => {
      this.checkToken();
    });

    // Verifica a cada mudança de rota
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.checkToken();
    });

    // Verifica também na inicialização
    this.checkToken();
  }

  private checkToken(): void {
    if (this.authService.AccessToken && this.authService.isTokenExpired()) {
      this.authService.logoff();
    }
  }
}
